import { forwardRef } from 'react';

import {
  useMonkeysBaseAppearance,
  useMonkeysComponentAttributes,
} from '../../provider/context';
import {
  resolveBaseAppearance,
  resolveBaseGridColumns,
  resolveBaseLayoutAlign,
  resolveBaseLayoutJustify,
  resolveBaseLayoutLength,
} from './theme';
import type { BaseGridProps } from './types';
import { cn } from './utils';

export const BaseGrid = forwardRef<HTMLDivElement, BaseGridProps>(
  function BaseGrid(
    {
      children,
      columns = 1,
      gap,
      align = 'stretch',
      justify = 'start',
      appearance,
      className,
      classNames,
      style,
      ...gridProps
    },
    ref,
  ) {
    const resolvedAppearance = useMonkeysBaseAppearance(appearance);
    const componentAttributes = useMonkeysComponentAttributes();
    const theme = resolveBaseAppearance(resolvedAppearance);
    const resolvedGap =
      gap === undefined
        ? undefined
        : resolveBaseLayoutLength('BaseGrid', 'gap', gap);

    return (
      <div
        {...componentAttributes}
        {...gridProps}
        ref={ref}
        data-monkeys-component="grid"
        data-slot="root"
        data-align={align}
        data-justify={justify}
        data-columns={columns}
        className={cn(theme.slots.gridRoot, classNames?.root, className)}
        style={{
          ...theme.styles.grid,
          gridTemplateColumns: resolveBaseGridColumns(columns),
          gap: resolvedGap,
          alignItems: resolveBaseLayoutAlign('BaseGrid', align),
          justifyContent: resolveBaseLayoutJustify('BaseGrid', justify),
          ...style,
        }}
      >
        {children}
      </div>
    );
  },
);
